import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ConditionsGenerales() {
  return (
    <div className="font-sans">
      <Navbar />
      <main className="pt-36 pb-24 bg-white">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <h1 className="font-heading font-bold text-navy-900 text-4xl mb-2">Conditions générales</h1>
          <p className="text-gray-400 text-sm mb-10">Dernière mise à jour : avril 2026</p>

          <div className="prose prose-sm max-w-none space-y-8 text-gray-600 leading-relaxed">
            <section>
              <h2 className="font-heading font-semibold text-navy-900 text-xl mb-3">1. Éditeur du site</h2>
              <div className="bg-gray-50 border-l-4 border-navy-900 pl-5 py-4 pr-4 rounded-r-lg">
                <p><strong className="text-navy-900">CICHORZ</strong></p>
                <p>Mariusz Slawomir Cichorz – Entrepreneur individuel</p>
                <p>SIRET : 102 737 178 00016</p>
                <p>57 Rue Lecourbe, 75015 Paris, France</p>
                <p>Email : mariuszc1chorzz@outlook.com</p>
                <p>Téléphone : +33 7 58 24 80 29</p>
              </div>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-navy-900 text-xl mb-3">2. Objet</h2>
              <p>Les présentes conditions générales régissent l'utilisation du site internet de CICHORZ. Le site présente les services de programmation informatique proposés par Mariusz Slawomir Cichorz.</p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-navy-900 text-xl mb-3">3. Propriété intellectuelle</h2>
              <p>Tous les contenus présents sur ce site (textes, images, logos, structure) sont protégés par le droit de la propriété intellectuelle et sont la propriété exclusive de CICHORZ. Toute reproduction, même partielle, est interdite sans autorisation préalable.</p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-navy-900 text-xl mb-3">4. Responsabilité</h2>
              <p>CICHORZ s'efforce de maintenir les informations du site à jour et exactes. Toutefois, l'éditeur ne saurait être tenu responsable des erreurs ou omissions, ni des dommages résultant de l'utilisation du site.</p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-navy-900 text-xl mb-3">5. Droit applicable</h2>
              <p>Les présentes conditions générales sont soumises au droit français. Tout litige relatif à leur interprétation ou exécution relève de la compétence des tribunaux français.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
